// @core/api/endpoints/search/validate_search_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ValidateSearchPolicyRequest,
  ValidateSearchPolicyResponse,
} from '../../../types/search';

const BASE_PATH = '/search';

/**
 * Validate search policy
 * Checks if a search query complies with data residency policies before sending to federation peers. Returns which fields/entity types are allowed or blocked by each peer's data policy.
 */
export async function ValidateSearchPolicy(
  data: ValidateSearchPolicyRequest,
  options?: RequestOptions
): Promise<ValidateSearchPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/search/validate-policy`;
  const requestOptions = options;
  return client.post<ValidateSearchPolicyResponse>(requestPath, data, requestOptions);
}
